import 'bootstrap/dist/css/bootstrap.min.css';

import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { RouteWithSidebar, RouteWithSiteHeader } from '../components/RouteWithBars';

import { UserList } from '../containers/user/list';
import { UserRegister } from '../containers/user/form/register';

import NotFound from '../containers/notFound';
import { HomeList } from '../containers/home/list';

import { StoreModel } from '../models/store.model';

// Novas telas traduzidas do PHP
import MainPage from '../containers/main/index';
import {ProcessList} from '../containers/process/list';

import Unauthorized from '../containers/unauthorized';
import { addLeadingSlash, removeTrailingSlash } from '../util';

import ResetPassword from '../containers/main/resetPassword';
import { entityConfig } from '../util/entityConfig';
import { getIsAdminFromToken } from '../util/tokenUtils';

const authenticatedHomePage = '/dash';

const SystemRoutes = () => {
  return (
		<>
			<Routes>
				<Route path="/404" element={<NotFound />} />
				<Route path="/401" element={<Unauthorized />} />
				<Route path="/" element={<MainPage />} />
				<Route path="/:login" element={<MainPage />} />
				<Route path="/Home" element={<MainPage />} />
				<Route path="/ResetarSenha/:hash" element={<ResetPassword />} />
				<Route
					path={entityConfig.PROCESS.rootUrl}
					element={<RouteWithSidebar component={ProcessList} />}
				/>

				<Route element={<PrivateRouteWithSidebar />}>
					<Route
						path={authenticatedHomePage}
						element={<RouteWithSidebar component={HomeList} />}
					/>
					<Route
						path={entityConfig.USER.rootUrl}
						element={<RouteWithSidebar component={UserList} />}
					/>
					<Route
						path={`${entityConfig.USER.rootUrl}/Cadastro`}
						element={<RouteWithSidebar component={UserRegister} />}
					/>
					<Route
						path={`${entityConfig.USER.rootUrl}/:mode/:id`}
						element={<RouteWithSidebar component={UserRegister} />}
					/>
					{/* <Route
            path={entityConfig.USER.rootUrl}
            element={<RouteWithSidebar component={UserList} />}
          />
          <Route path="/Usuario/Cadastro" element={<RouteWithSidebar component={UserRegister} />} />
          <Route
            path={`${entityConfig.USER.rootUrl}/:mode/:id`}
            element={<RouteWithSidebar component={UserRegister} />}
          /> */}
				</Route>
				<Route path="*" element={<Navigate to="/404" />} />
			</Routes>
		</>
	);
};

const PrivateRouteWithSidebar = () => {
  const authentication = useSelector((state: StoreModel) => state.authentication);
  const companyMenu = useSelector((state: StoreModel) => state.companyMenu);

  const location = useLocation();
  // Suporte a hash-router: extrai pathname após '#'
  const rawPath = location.hash ? location.hash.replace(/^#/, '') : location.pathname;
  const normalizedLocation = removeTrailingSlash(rawPath.toLowerCase());

  if (!authentication?.token) {
    return <Navigate to="/" />;
  }

  // REGRA: se admin = false, só pode acessar Processos
  const isAdmin = getIsAdminFromToken(authentication?.token);
  
  if (isAdmin === false) {
    const dashboardRoute = removeTrailingSlash('/dash');
    const userRoute = removeTrailingSlash('/usuario');
    const processRoute = removeTrailingSlash('/processo');

    // Se tentar acessar Dashboard/Usuários, redireciona para Processos
    if (
      normalizedLocation === dashboardRoute ||
      normalizedLocation.startsWith(dashboardRoute) ||
      normalizedLocation === userRoute ||
      normalizedLocation.startsWith(userRoute)
    ) {
      return <Navigate to={processRoute} replace />;
    }
  }

  // Se é admin, libera as rotas sem checar menu do backend
  if (isAdmin === true) {
    return <Outlet />;
  }

  let menuList = companyMenu;

  if (companyMenu === undefined || companyMenu.length === 0) menuList = authentication?.menu;

  if (
    normalizedLocation !== authenticatedHomePage &&
    !menuList?.some(
      (menu) =>
        menu.urlTarget !== null &&
        normalizedLocation.startsWith(
          addLeadingSlash(removeTrailingSlash(menu.urlTarget.toLowerCase()))
        )
    )
  ) {
    return <Navigate to="/401" />;
  }

  return <Outlet />;
};

export default SystemRoutes;
